import styled from 'styled-components';

export const ButtonBar = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: transparent;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: ${props => props.theme.spacing.default};
`;
